export default __webpack_public_path__ + "cb25ba47d0a5ea18d055efd8889419c5.svg";